module.exports = __webpack_public_path__ + "media/images/home-button-15de42fa3df08b14ad9c386d5a0e0941.png";